import { render, staticRenderFns } from "./MyProfileEditPage.vue?vue&type=template&id=a0bc98e8"
import script from "./MyProfileEditPage.vue?vue&type=script&lang=js"
export * from "./MyProfileEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports